import { motion } from "framer-motion";

// Line-by-line masked reveal for headings
export const lineParent = {
  hidden: {},
  show: { transition: { staggerChildren: 0.12, delayChildren: 0.1 } },
};

export const lineChild = {
  hidden: { y: "110%" },
  show: { y: 0, transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1] } },
};

export function MaskLine({ children, className = "" }) {
  return (
    <span className="reveal-mask">
      <motion.span variants={lineChild} className={`block ${className}`}>
        {children}
      </motion.span>
    </span>
  );
}

// Generic scroll reveal
export function Reveal({ children, className = "", delay = 0, y = 40 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay }}
    >
      {children}
    </motion.div>
  );
}
